import React from "react";
import { differenceInCalendarDays, parseISO }  from 'date-fns';
import { formatExpirationDate } from '../../../../utils/dateFormatters';
import warningCircle from '../../../../img/svg/warningCircle.svg';
import dangerTriangle from '../../../../img/svg/dangerTriangle.svg';
import { ContainerExpiteDate } from './styles'

function ExpireDateCourse({ course, size }) {
  const curso = course ?? {};

  const parsedExpiration = curso.data_fim_aulas ? parseISO(curso.data_fim_aulas) : null;
  const friendlyDate = formatExpirationDate(curso.data_fim_aulas);

  if (!parsedExpiration || Number.isNaN(parsedExpiration.getTime()) || !friendlyDate) {
    return null;
  }

  const today = new Date();
  const remainingDays = Math.max(differenceInCalendarDays(parsedExpiration, today), 0);

  return (
    <ContainerExpiteDate>
      {remainingDays <= 30 ? (
        <div className='date-course-danger'>
          <img src={dangerTriangle} alt="icon danger triangle" />
          <p className='date-course' style={{ fontSize: size }}>Você tem </p>
          <strong> {remainingDays}</strong>
          <p style={{ fontSize: size }}> {remainingDays === 1 ? 'dia' : 'dias'} até expirar </p>
        </div>
        ) : (
        <div className='date-course-warning'>
          <img src={warningCircle} alt="icon warning circle" />
          <p style={{ fontSize: size }}>Disponível até </p>
          <strong style={{ fontSize: size }}> {friendlyDate}</strong>
        </div>
        )
      }
    </ContainerExpiteDate>
  )
}

export default ExpireDateCourse;
